export const PAGE_PADDING = 20;
export const PAGE_MARGIN = 20;

export default () => ({
  form: {
    width: '100%',
    height: '100%',
  },
});
